const textTheme= {
  heading1:{
    display:'inline-block',
    fontSize: '32px',
    fontWeight: '700',
    marginBottom: '20px'
  },
  heading2 : {
    fontSize: '24px',
    fontWeight: '700',
    marginBottom: '20px'
  },
  heading3: {
    fontSize: '18px',
    fontWeight: '700'
  },
  primary : {
    fontSize: '16px',
    fontWeight: '400'
  },
  small : {
    fontSize: '12px',
    fontWeight: '400'
  }
}

export default textTheme